export default "https://cdn-static.gokick.com/assets/a667d1dc3297954618d7ed7be4de1ad72d2b7ee9/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";